import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "checkbox_idle",
  "use": "checkbox_idle-usage",
  "viewBox": "0 0 676 676",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 676 676\" id=\"checkbox_idle\">\n    <rect x=\"10\" y=\"10\" width=\"656\" height=\"656\" rx=\"30\" ry=\"30\" fill=\"#fff\" stroke=\"#c0c6ca\" stroke-width=\"20\" stroke-miterlimit=\"10\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol